module.exports = __webpack_public_path__ + "img/icon-none@2x.a08130cf.png";